import axios from 'axios';

const instance = axios.create({
  baseURL: "https://apinekros-mhermoso.sig-norba.com",
  withCredentials: true,
});

export default instance;